import React from 'react';
import type { OptionProps } from 'react-select';
import { components } from 'react-select';
import useAppSelector from '../../app/redux/useAppSelector';
import FloatingCard from '../../components/FloatingCard';
import HoverView from '../../components/HoverView';
import type { OptionTypeBase } from '../../components/Select';
import { UsageAnalyticsDays } from '../../organization/PricingConfig';
import InsightsRestriction from './InsightsRestriction';

const ReactSelectOption = components.Option;

type InsightsTimeOptionProps<
  OptionType extends OptionTypeBase,
  IsMulti extends boolean,
> = OptionProps<OptionType, IsMulti> & { onUpgradeClick: () => void };

const InsightsTimeOption = <
  OptionType extends OptionTypeBase,
  IsMulti extends boolean,
>({
  onUpgradeClick,
  innerProps,
  ...props
}: InsightsTimeOptionProps<OptionType, IsMulti>) => {
  const planTier = useAppSelector(
    (state) => state.session.organization.planTier,
  );

  const { value } = props.data;

  if (
    typeof value === 'number' &&
    planTier &&
    value > UsageAnalyticsDays[planTier]
  ) {
    return (
      <HoverView
        hoverDelay="fast"
        hoverGroupId="insightsTimeOption"
        placement="left"
        view={
          <FloatingCard>
            <InsightsRestriction onUpgradeClick={onUpgradeClick} />
          </FloatingCard>
        }
      >
        <div>
          <ReactSelectOption
            {...props}
            isDisabled
            innerProps={{ ...innerProps, onClick: () => {} }}
          />
        </div>
      </HoverView>
    );
  }

  return <ReactSelectOption {...props} innerProps={innerProps} />;
};

export default InsightsTimeOption;
